import { actions } from '@gocanvas/client'

const { loadFormData } = actions

export { loadFormData }
